import React from "react";
import styled from "styled-components";
import "../DropdownCardComponent/style.css";
import { CustomLabel, typeOfCal } from "../../Constant";
import DropdownCardContent from "./DropDownInput";
import { useSelector } from "react-redux";
import PADropdownCardContent from "./PADropdownCardContent";
import SarvahDropDownCardContent from "./SarvahDropDownCardContent";

const DropDownCardStyle = styled.div`
  background-color: #f2f2f2;
  width: 400px;
  position: absolute;
  top: 60px;
  z-index: 999;
  visibility: ${(props) => (props.open ? "visible !important" : "hidden")};
  opacity: ${(props) => (props.open ? "1 !important" : "0")};
  transition: 0.1s;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  &:hover {
    box-shadow: 0 0 32.2px 2.8px rgba(244, 126, 31, 0.2);
  }
  @media (max-width: 767px) {
    width: 310px;
  }
`;

const UparrowDiv = styled.div`
  width: 0;
  height: 0;
  border-width: 0 15px 20px 15px;
  border-color: transparent transparent #f2f2f2 transparent;
  border-style: solid;
  position: absolute;
  z-index: 1001;
  top: -20px;
`;

const CI_PAdropdownComponent = ({
  data,
  dropDownopen,
  onCancel,
  onDataChange,
  onOk,
  ageError
}) => {
  const typeOfCalculator = useSelector((state) => state.common.type);

  return (
    <DropDownCardStyle open={dropDownopen}>
      <UparrowDiv></UparrowDiv>
      <div className="BoxCloseCross" onClick={onCancel}>
        <CustomLabel font_size="16">&nbsp;X&nbsp;</CustomLabel>
      </div>
      {data.adultData.length > 0 &&
        data.adultData.map((ei, i) => (
          <React.Fragment key={`${ei?.dob}-${i}`}>
            {typeOfCalculator === typeOfCal.ci && (
              <DropdownCardContent
                lable={"Adult"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
            {typeOfCalculator === typeOfCal.accident_Shield && (
              <DropdownCardContent
                lable={"Adult"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
            {typeOfCalculator === typeOfCal.pa && (
              <PADropdownCardContent
                lable={"Adult"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
             {typeOfCalculator === typeOfCal.mchiSarvah && (
              <SarvahDropDownCardContent
                lable={"Adult"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
          </React.Fragment>
        ))}
      {data.childData.length > 0 &&
        data.childData.map((ei, i) => (
          <React.Fragment key={`${ei.dob}-${i}`}>
            {typeOfCalculator === typeOfCal.ci && (
              <DropdownCardContent
                lable={"Child"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
            {typeOfCalculator === typeOfCal.accident_Shield && (
              <DropdownCardContent
                lable={"Child"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
            {typeOfCalculator === typeOfCal.pa && (
              <PADropdownCardContent
                lable={"Child"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
              {typeOfCalculator === typeOfCal.mchiSarvah && (
              <SarvahDropDownCardContent
                lable={"Child"}
                num={i + 1}
                p_data={ei}
                onDataChange={onDataChange}
                user_data_info={data}
              />
            )}
          </React.Fragment>
        ))}
      {  (
        <span className=" my-2">
          <CustomLabel color="red" font_size="12">
            <ul>
              {typeOfCalculator === typeOfCal.ci && data.adultData.filter((ei) => ei.annualI > 0).some((ei) => !(ei.annualI >= 10000 && ei.annualI <= 100000000)) && <li> Annual Income Should between 10,000 to 100Cr</li>}
              {typeOfCalculator === typeOfCal.accident_Shield && data.adultData.filter((ei) => ei.annualI > 0).some((ei) => !(ei.annualI >= 125000 && ei.annualI <= 100000000)) && <li> Annual Income Should between 1,25,000 to 100Cr</li>}
              {typeOfCalculator === typeOfCal.pa && data.adultData.filter((ei) => ei.annualI > 0).some((ei) => !(ei.annualI >= 50000)) && <li>Minimum annual income should be at least ₹50,000 for an earning member.</li>}
              {typeOfCalculator === typeOfCal.mchiSarvah &&
                data.adultData.filter((ei) => ei.annualI > 0)
                  .some((ei) => !(ei.annualI >= 25000)) &&
                <li>Minimum annual income should be at least ₹25,000 for an earning member.</li>}
            </ul>
          </CustomLabel>
        </span>
      )}

      
      {ageError && (
        <span className="center my-2">
          <CustomLabel color="red" font_size="12">
            {typeOfCalculator === typeOfCal.accident_Shield && <ul>
              <li>Age for adult (Self, Husband, Wife, Father and Mother) should be between 18 to 70</li>
              <li>Age of adult Son and Daughter should be between 18 to 25</li>
              <li> Age of kid should be between 05 to 25</li>
            </ul>}
            {typeOfCalculator === typeOfCal.ci && (
              <ul>
                <li>Age for adult (Self, Husband, Wife, Father and Mother) should be between 18 to 65</li>
                <li>Age of adult Brother, Sister, Son and Daughter should be between 18 to 25</li>
                <li> Age of kid should be between 18 to 25</li>
              </ul>
            )}
            {typeOfCalculator === typeOfCal.pa && (
              <ul>
                <li>Age for adult (Self, Husband, Wife, Father and Mother) should be between 18 to 80.</li>
                <li>Age of adult Brother, Sister should be between 18 to 25.</li>
                <li>Age of kid should be between 91 days to 25 years</li>
              </ul>
            )}
             {typeOfCalculator === typeOfCal.mchiSarvah && (
              <ul>
                <li>Age for adult should be between 18-120 years.</li>
                <li>Age of Kid should be between 91 days to 30 years.</li>
              </ul>
            )}
          </CustomLabel>
        </span>
      )}
       <span className="center my-2">
          <CustomLabel color='grey' font_size="12">
            {(typeOfCalculator === typeOfCal.pa || typeOfCalculator === typeOfCal.accident_Shield) && (
              <ul>
                <li>In case of a dependent Spouse, the minimum Sum Insured value for the earning member should be at least ₹10,00,000.</li>
                <li>In case of dependent Children/Parents/Siblings/Parent-in-Laws, the minimum Sum Insured value for the earning member should be at least ₹20,00,000.</li>
              </ul>
            )}
             {(typeOfCalculator === typeOfCal.ci ) && (
               <ul>
               <li>In case of a dependent Spouse, the minimum Sum Insured value for the earning member should be at least ₹ 200000</li>
               <li>In case of dependent Children/Parents/Siblings/Parent-in-Laws, the minimum Sum Insured value for the earning member should be at least ₹400000</li>
             </ul>
             )}
              {(typeOfCalculator === typeOfCal.mchiSarvah) && (
            <ul>
              <li>In ‘Select Relationship’, choose the relationship of the insured member with the Proposer of the policy.</li>
              <li>In case, if the proposer is same as insured, then select relationship as “SELF”.</li>
            </ul>
          )}
          </CustomLabel>
        </span>
      <div className="my-3 center">
        <button className="btn-primary-btn" type="button" onClick={onOk}>
          Ok
        </button>
      </div>
    </DropDownCardStyle>
  );
};

export default CI_PAdropdownComponent;
